import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { CoachingService } from '../service/coaching.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ThemePalette } from '@angular/material/core';
import { Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
// import * as pdfjs from 'pdfjs-dist/build/pdf';
import * as pdfjs from 'pdfjs-dist';
// import { getDocument } from "pdfjs-dist/legacy/build/pdf.mjs";
// import * as pdfWorker from "pdfjs-dist/build/pdf.worker.mjs";
// import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";

// const pdfPath = "../../assets/1.pdf";
// const pdfWorker = "../../assets/pdf.worker.mjs";

// const pdfWorker = "pdf.worker.min.mjs";


@Component({
  selector: 'app-coaching-attachment',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle, 
    MatDialogContent,
    MatDialogModule, 
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    RouterLink,
    MatToolbarModule,
  ],
  templateUrl: './coaching-attachment.component.html',
  styleUrl: './coaching-attachment.component.css'
})
export class CoachingAttachmentComponent implements OnInit {
  color : ThemePalette = 'accent';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private coachingService: CoachingService,
    private location: Location,
  ) {}
  showImg = false;
  imgBase64String = '';
  showPdf = false;
  pdfBase64String = '';
  isLoading = false;
  pdfUrl!:any;
  safePdfUrl!:any;
  jpgUrl!:any;
  ngOnInit(): void {
    let index = this.data.kpi?.attachment.lastIndexOf('.');
    let format = this.data.kpi?.attachment.substring(index + 1);
    let formatLowerCase = format?.toLowerCase();
    if(formatLowerCase?.includes('pdf')){
      this.showPdfDocV5(this.data.kpi?.getAttachmentS3Url);
      this.showPdf = true;
    }
    if(formatLowerCase?.includes('jpg')){
      this.showJpgV2(this.data.kpi?.getAttachmentS3Url);
      this.showImg = true;
    }
    if(formatLowerCase?.includes('png') ){
      this.showJpgV2(this.data.kpi?.getAttachmentS3Url);
      this.showImg = true;
    }
  }  
  jpgSafeUrl(){
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.jpgUrl);
  }
  showJpg(binaryData:Blob){
    var objectURL = URL.createObjectURL(binaryData);
    this.jpgUrl = objectURL;
  }
  showJpgV2(urlString:string){
    
    this.jpgUrl = urlString;
  }  
  pdfURL() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl);
  }
  showPdfDoc(binaryData:Blob) {    
    var blob = new Blob([binaryData], { type: 'application/pdf' });
    console.log(`blob = ${blob}`);
    console.log(`window.URL = ${window.URL}`);
    console.log(`window.webkitURL = ${window.webkitURL}`);
    // var URL = window.URL || window.webkitURL;
    // var objectURL = URL.createObjectURL(blob);
    var objectURL = window.webkitURL.createObjectURL(blob);
    console.log(`objectURL = ${objectURL}`);
    // var objectURL = (window.URL || window.webkitURL).createObjectURL(blob);
    this.pdfUrl = objectURL;
    // window.location.href = objectURL;
  }
  async showPdfDocV2(binaryData:Blob) {    
    var blob = new Blob([binaryData], { type: 'application/pdf' });

    // console.log(`blob = ${blob}`);
    // console.log(`window.URL = ${window.URL}`);
    // console.log(`window.webkitURL = ${window.webkitURL}`);

    // var URL = window.URL || window.webkitURL;
    // var objectURL = URL.createObjectURL(blob);

    // var objectURL = window.webkitURL.createObjectURL(blob);
    // console.log(`objectURL = ${objectURL}`);

    // var objectURL = (window.URL || window.webkitURL).createObjectURL(blob);
    
    const buffer = await binaryData.arrayBuffer();

    const byteArray = new Uint8Array(buffer);

    const charArray = Array.from(byteArray, byte => String.fromCharCode(byte));

    const binaryString = charArray.join("");

    const encodedData = window.btoa(binaryString);
    console.log(`encodedData = ${encodedData}`);
    this.pdfUrl = `data:application/pdf;base64,` +encodedData;
    // window.location.href = objectURL;
  }
  @ViewChild('pdfViewer') pdfViewer!: ElementRef;
  // async showPdfDocV3(binaryData:Blob) { 
  //   // const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.mjs');

  //   // pdfjs.GlobalWorkerOptions.workerSrc =  "pdfjs-dist/build/pdf.worker.mjs";
  //   // pdfjs.GlobalWorkerOptions.workerSrc =  pdfWorker;
  //   pdfjs.GlobalWorkerOptions.workerSrc =  'pdf.worker.js';

  //   const buffer = await binaryData.arrayBuffer();

  //   // pdfjs.getDocument(pdfPath).promise.then(pdf => {
  //   pdfjs.getDocument(buffer).promise.then(pdf => {
  //     for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
  //       pdf.getPage(pageNum).then(page => {
  //         const canvas = document.createElement('canvas');
  //         const context = canvas.getContext('2d');
  //         const viewport = page.getViewport({ scale: 1.0 });

  //         canvas.width = viewport.width;
  //         canvas.height = viewport.height;

  //         const renderContext = {
  //           canvasContext: context!,
  //           viewport: viewport
  //         };

  //         page.render(renderContext);
  //         this.pdfViewer.nativeElement.appendChild(canvas);
  //       });
  //     }
  //   });
  // }
  showPdfDocV4() { 
    this.pdfUrl = this.data.kpi?.getAttachmentS3Url;
  }
  async showPdfDocV5(urlString:string) { 
    // pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;
    pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.3.136/build/pdf.worker.mjs';

    // pdfjs.GlobalWorkerOptions.workerSrc =  'pdf.worker.mjs';
    // pdfjs.GlobalWorkerOptions.workerSrc = pdfjs.PDFWorker.workerSrc;
    // pdfjs.getDocument(urlString).promise.then(pdf => {
    pdfjs.getDocument({
      url: urlString,      
      cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.3.136/cmaps/',
      cMapPacked: true,
    }).promise.then(pdf => {
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        pdf.getPage(pageNum).then(page => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const viewport = page.getViewport({ scale: 1.0 });

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          const renderContext = {
            canvasContext: context!,
            viewport: viewport
          };
          page.render(renderContext);
          this.pdfViewer.nativeElement.appendChild(canvas);
        });
      }
    });
  }
  binaryFileDownload = (res: any, fileName: string) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const blob: any = new Blob([res], { type: 'application/binary' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }
  backClicked() {
    this.location.back();
  }
}
